/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Upgrade_ProInputs */

const en_settings_upgrade_pro = /** @type {(inputs: Settings_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to Pro`)
};

const de_settings_upgrade_pro = /** @type {(inputs: Settings_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Pro upgraden`)
};

const fr_settings_upgrade_pro = /** @type {(inputs: Settings_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer à Pro`)
};

const es_settings_upgrade_pro = /** @type {(inputs: Settings_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar a Pro`)
};

const it_settings_upgrade_pro = /** @type {(inputs: Settings_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa a Pro`)
};

const nl_settings_upgrade_pro = /** @type {(inputs: Settings_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade naar Pro`)
};

const pl_settings_upgrade_pro = /** @type {(inputs: Settings_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź na Pro`)
};

const fi_settings_upgrade_pro = /** @type {(inputs: Settings_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä Pro`)
};

const da_settings_upgrade_pro = /** @type {(inputs: Settings_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader til Pro`)
};

const sv_settings_upgrade_pro = /** @type {(inputs: Settings_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera till Pro`)
};

/**
* | output |
* | --- |
* | "Upgrade to Pro" |
*
* @param {Settings_Upgrade_ProInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_upgrade_pro = /** @type {((inputs?: Settings_Upgrade_ProInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Upgrade_ProInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_upgrade_pro(inputs)
	if (locale === "fr") return fr_settings_upgrade_pro(inputs)
	if (locale === "es") return es_settings_upgrade_pro(inputs)
	if (locale === "it") return it_settings_upgrade_pro(inputs)
	if (locale === "nl") return nl_settings_upgrade_pro(inputs)
	if (locale === "pl") return pl_settings_upgrade_pro(inputs)
	if (locale === "fi") return fi_settings_upgrade_pro(inputs)
	if (locale === "da") return da_settings_upgrade_pro(inputs)
	if (locale === "sv") return sv_settings_upgrade_pro(inputs)
	return en_settings_upgrade_pro(inputs)
});